import { SetIsPrintAction, SET_IS_PRINT } from './types';

export function setIsPrint(isPrint: boolean): SetIsPrintAction {
  return {
    type: SET_IS_PRINT,
    payload: { isPrint },
  };
}
